const Drawer = {
  defaultProps: {},
  styleOverrides: {
    paper: ({ theme }) => ({
      borderRadius: 0,
      backgroundColor: theme.palette.background.default,
    }),
  },
};

export default Drawer;
